import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { GetUserById } from "../../pages/settings/actions";
import Tabs from "./component";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      GetUserByIdConnect: GetUserById,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);
